(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tms-additonal-services"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tms-additional-services')) {
    customElements.define('tms-additional-services', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('submit', this.addService, options);
        this.events = import('@shopify/events').catch(() => null);
        this.events.then(events => {
          if (!events || !this.isConnected || options.signal.aborted) return;
          document.addEventListener(events.StandardEvents.cartLinesUpdate, event => {
            event.promise?.then(result => {
              if (result.detail?.items) this.updateButtons(result.detail.items);
            }).catch(() => {});
          }, options);
        });
      }

      disconnectedCallback() { this.controller?.abort(); }

      updateButtons(items) {
        this.querySelectorAll('[data-service-row]').forEach(row => {
          const count = items.filter(item => String(item.variant_id) === row.dataset.variant).reduce((sum, item) => sum + item.quantity, 0);
          const button = row.querySelector('button');
          if (!button) return;
          button.disabled = this.busy || (row.dataset.once === 'true' && count > 0);
          button.querySelector('[data-button-label]').textContent = count > 0 ? (row.dataset.once === 'true' ? this.dataset.addedLabel : this.dataset.anotherLabel) : this.dataset.addLabel;
        });
      }

      addService = async event => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches('.tms-services__form')) return;
        event.preventDefault();
        if (this.busy) return;
        this.busy = true;
        const status = this.querySelector('[role="status"]');
        status.textContent = '';
        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('button').forEach(button => { button.disabled = true; });
        const root = window.Shopify?.routes?.root || '/';
        let sent = false;
        let cart;
        try {
          const before = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!before.ok) throw new Error();
          cart = await before.json();
          const row = form.closest('[data-service-row]');
          if (row.dataset.once === 'true' && cart.items.some(item => String(item.variant_id) === row.dataset.variant)) {
            status.textContent = this.dataset.addedLabel;
            return;
          }
          const data = new FormData(form);
          const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))].slice(0, 5);
          if (sections.length) data.set('sections', sections.join(','));
          data.set('sections_url', location.pathname);
          sent = true;
          const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
          const result = await response.json();
          if (!response.ok || result.status) {
            sent = false;
            throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          }
          const after = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!after.ok) throw new Error();
          cart = await after.json();
          const events = await this.events;
          if (!events) { window.location.assign(this.dataset.cartUrl); return; }
          const { CartLinesUpdateEvent } = events;
          this.dispatchEvent(new CartLinesUpdateEvent({
            action: 'add', context: 'product',
            lines: [{ merchandiseId: row.dataset.variant, quantity: 1 }],
            promise: Promise.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, sections: result.sections, source: 'product-form-component', sourceId: form.id, itemCount: 1, didError: false }
            })
          }));
          status.textContent = this.dataset.success;
        } catch (error) {
          if (sent) { window.location.assign(this.dataset.cartUrl); return; }
          status.textContent = error.message || this.dataset.error;
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          if (cart) this.updateButtons(cart.items);
          else this.querySelectorAll('button').forEach(button => { button.disabled = false; });
        }
      };
    });
  }
  } catch(e) { console.error(e); }
})();

})();
